import { render, staticRenderFns } from "./BuyerVideo.vue?vue&type=template&id=7368a69c&scoped=true&"
import script from "./BuyerVideo.vue?vue&type=script&lang=js&"
export * from "./BuyerVideo.vue?vue&type=script&lang=js&"
import style0 from "./BuyerVideo.vue?vue&type=style&index=0&id=7368a69c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7368a69c",
  null
  
)

export default component.exports